import { ReactElement, useState } from "react"

import { Button } from "@wfp/ui"

import { useNavigate } from "react-router-dom"
import ProgressStepper from "../../components/Shared/ProgressStepper/ProgressStepper"

import { modaSteps } from "../../constants/markets"
import { MappingSteps, ModaUploadSteps } from "../../interfaces/markets"

import SelectedFields from "../../components/Markets/ModaMapping/SelectedFields"
import { useDataModaUploadContext } from "../../providers/DataModaUploadContext"

const ModaUploadPage = (): ReactElement => {
  const navigate = useNavigate()
  const { checkIfNextDisabled, setKeyValue, keyValue } = useDataModaUploadContext()

  const [activeStep, setActiveStep] = useState<number>(ModaUploadSteps.CONFIG)
  const [subStep, setSubStep] = useState<number>(MappingSteps.HEADER)

  const hasSubSteps = () => {
    return !!modaSteps[activeStep]?.substeps
  }
  const getActiveSubSteps = () => {
    if (!modaSteps[activeStep]?.substeps) return null
    return modaSteps[activeStep].substeps?.find(sub => sub.id === subStep)
  }

  const handleBack = (): void => {
    if (hasSubSteps() && subStep > 1) {
      setSubStep(subStep - 1)
      return
    }
    if (activeStep === ModaUploadSteps.CONFIG) {
      keyValue === null ? navigate("/market-prices/Dashboard") : setKeyValue(null)
      return
    }
    setActiveStep(activeStep - 1)
  }

  const handleNext = (): void => {
    if (hasSubSteps() && subStep < 3) {
      setSubStep(subStep + 1)
      return
    }
    if (activeStep === ModaUploadSteps?.VALIDATION) {
      navigate("/market-prices/Dashboard")
    }
    setActiveStep(activeStep + 1)
  }

  return (
    <div className="mx-4">
      <div className="w-full border-b-2 border-solid border-gray-200 pb-1 pt-2 sticky top-0 bg-white z-10">
        <ProgressStepper steps={modaSteps} currentStep={activeStep} />
      </div>

      {hasSubSteps() ? (
        <div className="mt-2 min-h-[52vh] px-4">{getActiveSubSteps()?.content || "No Content Available"}</div>
      ) : (
        <div className="mt-2 min-h-[52vh] px-4">{modaSteps[activeStep]?.content}</div>
      )}

      <div className="flex justify-between align-center mt-4 w-full border-t-2 border-solid border-gray-200 pt-2 sticky bottom-0 bg-white z-10">
        <Button kind="secondary" onClick={handleBack} disabled={modaSteps[activeStep]?.id === ModaUploadSteps.FINALIZE}>
          Back
        </Button>
        {getActiveSubSteps()?.showMappedField && <SelectedFields />}
        <Button
          kind="secondary"
          onClick={handleNext}
          disabled={checkIfNextDisabled(modaSteps[activeStep]?.id, subStep)}
        >
          {modaSteps[activeStep]?.nextAction || "Next"}
        </Button>
      </div>
    </div>
  )
}

export default ModaUploadPage
